






































































import { Component, Vue } from 'vue-property-decorator';
import { LeuteUndGeldReportModel, LeuteUndGeldViewModel } from '@/services/api/nswag/stapiclient_generated';
import { stAdminApi } from '@/services/st-api';
import StTabs from '@/components/tabs/StTabs.vue';
import AccountSettingsInvoice from '@/views/Settings/AccountSettingsInvoice.vue';
import StBadge from '@/components/basic/StBadge.vue';
import LeuteUndGeldTable from '@/views/Admin/LeuteUndGeldTable.vue';

@Component({
  components: { LeuteUndGeldTable, StBadge, StTabs, AccountSettingsInvoice },
})
export default class LeuteUndGeld extends Vue {
  leute: LeuteUndGeldViewModel = LeuteUndGeldViewModel.fromJS({});
  report: LeuteUndGeldReportModel = LeuteUndGeldReportModel.fromJS({});
  level = '';
  loading: boolean = true;
  lostDays: number = 30;

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    this.loading = true;
    this.leute = await stAdminApi.getLeuteUndGeld();
    this.report = await stAdminApi.getLeuteUndGeldBesser(this.lostDays);
    this.loading = false;
  }
}
